import { ResultCard } from '@globalvisioninc/ui/result-card';
import type { ReactNode } from 'react';

export type DifferenceCardGraphicsProps = {
  source: ReactNode;
  target: ReactNode;
  sourceLabel: string;
  targetLabel: string;
  isFound?: boolean;
};

const DifferenceCardGraphics = ({
  source,
  target,
  sourceLabel,
  targetLabel,
  isFound = true,
}: DifferenceCardGraphicsProps) => (
  <ResultCard.Row>
    <ResultCard.Graphics
      source={source}
      target={target}
      sourceLabel={sourceLabel}
      targetLabel={targetLabel}
      isFound={isFound}
    />
  </ResultCard.Row>
);

export default DifferenceCardGraphics;
